import React from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'
import CashManagement from './CashManagement'
import Settings from './Settings'
import OpenClose from './OpenClose'
import SalesHistory from './SalesHistory'
import Sell from './Sell'
import SaleLogs from './LogTracking'
import Status from './Status'

const SellParent = ({ match }) => (
  <Switch>
    <Route path={`${match.url}/cashmanagement`} component={CashManagement} />
    <Route path={`${match.url}/settings`} component={Settings} />
    <Route path={`${match.url}/openclose`} component={OpenClose} />
    <Route path={`${match.url}/salehistory`} component={SalesHistory} />
    <Route path={`${match.url}/mainsale`} component={Sell} />
    <Route path={`${match.url}/tracking`} component={SaleLogs} />
    <Route path={`${match.url}/status`} component={Status} />
  </Switch>
)

export default SellParent
